import * as React from "react";
const ClosedBusniessIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aClosedBusniessIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aClosedBusniessIcon)">
      <path
        fill={props.fill}
        d="M3.334 18c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V7.167c0-.459.163-.851.49-1.177.326-.327.718-.49 1.177-.49h3.333V3.833c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h3.333c.458 0 .85.164 1.177.49.327.327.49.72.49 1.177V5.5h3.333c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v9.166c0 .459-.163.851-.49 1.178-.326.326-.719.49-1.177.49H3.334Zm5-12.5h3.333V3.833H8.334V5.5Zm8.333 7.5H12.5v1.667h-5V13H3.334v3.333h13.333V13Zm-7.5 0h1.667v-1.667H9.167V13Zm-5.833-1.667H7.5V9.667h5v1.666h4.167V7.167H3.334v4.166Z"
      />
    </g>
  </svg>
);
export default ClosedBusniessIcon;
